export const STORY_TYPES = 'STORY_TYPES';
export const STORIES = 'STORIES';
export const STORY_BY_ID = 'STORY_BY_ID';
